module.exports = __webpack_public_path__ + "static/lifestyle1-47a87af8717b502678941973962c260d.jpg";